import { TimeRange } from "sbtech-sports-data-api-client";
import { SportDataGatewayQueryInfo } from "sb-bff-integration";
export const preLiveSportApiQuery = (handler, languageCode, from) => {
    const query = "$filter=fixturesCount gt 0";
    const queryInfo = new SportDataGatewayQueryInfo(query, handler);
    queryInfo.timeRange = TimeRange.SixHours;
    queryInfo.locale = languageCode;
    queryInfo.from = from.toISOString();
    return queryInfo;
};
export const preLiveSportApiQueryFactory = (languageCode, dateConstructor) => {
    return (handler) => preLiveSportApiQuery(handler, languageCode, new dateConstructor());
};
export const liveSportApiQuery = (handler, languageCode) => {
    const query = "$filter=liveFixturesTotalCount gt 0 or liveOutrightsTotalCount gt 0";
    const queryInfo = new SportDataGatewayQueryInfo(query, handler);
    queryInfo.locale = languageCode;
    return queryInfo;
};
export const liveSportApiQueryFactory = (languageCode) => {
    return (handler) => liveSportApiQuery(handler, languageCode);
};
export const todaySportApiQuery = (handler, languageCode, from) => {
    const queryInfo = new SportDataGatewayQueryInfo("", handler);
    queryInfo.timeRange = TimeRange.OneDay;
    queryInfo.locale = languageCode;
    queryInfo.from = from.toISOString();
    return queryInfo;
};
export const todaySportApiQueryFactory = (languageCode) => {
    return (fromProvider) => (handler) => todaySportApiQuery(handler, languageCode, fromProvider());
};
//# sourceMappingURL=SportApiQueries.js.map